import { cn } from '../../lib/cn';

type Step = { label: string; completed?: boolean; active?: boolean };

type Props = {
  steps: Step[];
  progress?: number;
  estimatedMinutes?: number;
  className?: string;
};

export function ProgressTracker({ steps, progress, estimatedMinutes, className }: Props) {
  const completed = steps.filter((s) => s.completed).length;
  const pct = progress ?? Math.round((completed / steps.length) * 100);

  return (
    <div className={cn(className)}>
      <div className="flex items-center justify-between text-xs text-slate-500">
        <span>{completed} of {steps.length} steps</span>
        {estimatedMinutes != null && <span>~{estimatedMinutes} min remaining</span>}
      </div>
      <div className="mt-2 h-2 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
        <div
          className="h-full rounded-full bg-brand-600 transition-all"
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={pct}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
      <ol className="mt-4 space-y-2">
        {steps.map((step, i) => (
          <li
            key={step.label}
            className={cn(
              'flex items-center gap-2 text-sm',
              step.completed && 'text-success-700 dark:text-success-400',
              step.active && 'font-medium text-brand-700 dark:text-brand-300',
              !step.completed && !step.active && 'text-slate-500',
            )}
          >
            <span className={cn(
              'flex h-5 w-5 items-center justify-center rounded-full text-xs',
              step.completed && 'bg-success-100 text-success-700 dark:bg-success-950',
              step.active && 'bg-brand-100 text-brand-700 dark:bg-brand-950',
              !step.completed && !step.active && 'bg-slate-100 dark:bg-slate-800',
            )}>
              {step.completed ? '✓' : i + 1}
            </span>
            {step.label}
          </li>
        ))}
      </ol>
    </div>
  );
}
